import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Fuelgrade(props) {
  
 
    const { globalfilter, screen, updateParent, reset, type } = props;

    //const {filtercomObj, setfiltercomObj } = useContext(FilterContext);

    const [filteredString, setValue] = useState("");
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [customerDetailsBySearch, setCustomerDetailsBySearch] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const autoTextCustomer = async (event) => {
        
        //const searchStr = event.target.value;
        //setValue(searchStr);
        try {
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/Fuelgrade`;
            const res = await getRequest(url);
            if (res?.status === 200) {
                // let newresult
                let data = res?.data || [];
                let result = data?.map((a, i) => {
                    return { id: a?.fuelGrade, name: a?.fuelGrade };
                });
                if (selectedvalue) {
                    selectedvalue.forEach((val, i) => {
                        result = result.filter((ele) => ele.name != val.name)
                    })
                }
                //console.log('new', newresult)
                setCustomerDetailsBySearch(result);
                return;
            }
            //ToastError(res?.data?.message || 'Failed to fetch');
        } catch (err) {
            console.log('Failed to fetch customer keys', err);
            //ToastError(err?.response?.data?.message || 'Failed to fetch data');
        }

    }

    const handleChange = (event, newValue, type) => {
        
        
        props.onChange(newValue);
        const filteredFqtfuelgrade = {
            ...formObj,
            Fqtfuelgrade: newValue
        };
        setFormObj({ ...filteredFqtfuelgrade });
        setselectedvalue(newValue);
       setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                Fqtfuelgrade: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    React.useEffect(() => {
        //
        console.log(formObj)
    }, formObj)

    const defaultValue = (val) => {
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Fqtfuelgrade: filtervalue.Fqtfuelgrade
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Fqtfuelgrade);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            console.log('getcookievalue', formObj)
            setselectedvalue(Obj.Fqtfuelgrade);
        }else{
            setFormObj({});
        }
    }

    React.useEffect(() => {
        //
        if (reset>0)
            defaultValue(GlobalFilterSettingValue);

    }, [reset]);

    React.useEffect(() => {
        defaultValue(GlobalFilterSettingValue);
        autoTextCustomer();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.Fqtfuelgrade || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={customerDetailsBySearch}
                getOptionLabel={(option) => option.name}
                inputProps={{
                    name: 'customer',
                    id: 'outlined-customer-native-simple',
                }}
                //onChange={(e) => onValuesChange(e.target.value, "ViscosityNo1")} 
                onChange={(event, newValue) => handleChange(event, newValue, type)}
               inputValue={filteredString}

                renderInput={(params) => (

                    <TextField
                        {...params}
                        variant="standard"
                        label="Fuel Grade"
                        placeholder=""
                        onChange={autoTextCustomer}
                    //value={formObj.customerNameKey}
                    //value={'one'}
                    />
                )}

            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
